<template>
  <footer class="l-footer">
    <ul v-if="!isRegistrationRoute" class="l-footer__links">
      <li class="l-footer__links__item">
        <a target="_blank" :href="help" @click="handleHelpClick">
          {{ $t('layouts.footer.help') }}
        </a>
      </li>
      <!-- NOTE: 導線復活させる可能性あるのでコメントアウト -->
      <!-- <li class="l-footer__links__item">
        <a target="_blank" :href="allServiceUrlConst[useService].contact">
          {{ $t('layouts.footer.contact') }}
        </a>
      </li> -->
      <li class="l-footer__links__item">
        <a target="_blank" :href="allServiceUrlConst[useService].privacy">
          {{ $t('layouts.footer.privacy') }}
        </a>
      </li>
      <li class="l-footer__links__item">
        <a target="_blank" :href="terms">
          {{ $t('layouts.footer.terms') }}
        </a>
      </li>
      <li class="l-footer__links__item">
        <a target="_blank" :href="allServiceUrlConst[useService].homepage">
          {{ $t('layouts.footer.company') }}
        </a>
      </li>
      <li class="l-footer__links__item">
        <a v-if="currentUserAdmin" href="/admin/distributers">
          {{ $t('layouts.footer.admin') }}
        </a>
      </li>
      <li v-if="currentDistributerUuid" class="l-footer__links__item">
        <a :href="`/distributers/${ currentDistributerUuid }/companies`">
          {{ $t('layouts.footer.distributer') }}
        </a>
      </li>
    </ul>
    <small class="l-footer__copy">{{ allServiceUrlConst[useService].copyright }}</small>
    <p class="l-footer__note">
      {{ $t('layouts.footer.npsLicense') }}
    </p>
  </footer>
</template>

<script>
import { allServiceUrlConst } from '../modules/serviceUrlConst'
import {mapGetters} from 'vuex'
import { actionEvent } from 'src/biz_spa/modules/googleAnalytics'
export default {
  name: 'Footer',
  props: {
    currentUser: {
      default: null
    },
    useService: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      isDocomoPlan: 'companiesCompany/isDocomoPlan',
    }),
    currentDistributerUuid: function () {
      if (this.currentUser) return this.currentUser.distributer_uuid
      return null
    },
    currentUserAdmin: function () {
      if (this.currentUser) return this.currentUser.admin
      return false
    },
    isRegistrationRoute() {
      return this.$route.path.includes('registrations')
    },
    allServiceUrlConst: () => allServiceUrlConst,
    terms() {
      return this.isDocomoPlan ? 'https://biz.kutikomi.com/docomo_service_term.pdf' : this.allServiceUrlConst[this.useService].terms

    },
    help() {
      return this.isDocomoPlan ? 'https://movinc.notion.site/2c25576b9def4e61a255891b7b076c1f?pvs=4' : this.allServiceUrlConst[this.useService].help
    },
  },
  methods: {
    handleHelpClick() {
      actionEvent('FooterHelp')
    }
  }
}
</script>
